import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { MyDate, myAxios, weeknum } from "src/components/common/functions";

const allowedKeys = ["mode", "month", "week", "fleetNumber", "trendFleetNumber"] as const;

export async function fleetUsageLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());

    const url = new URL(request.url);
    const today = new MyDate();
    const defaultMode = "Month";
    const defaultMonth = today.s().slice(0, 7);
    const defaultWeek = weeknum(today);
    let shouldRedirect = false;

    for (const [key] of url.searchParams) {
        if (!allowedKeys.includes(key as typeof allowedKeys[number])) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }

    const mode = url.searchParams.get("mode");
    if (mode !== "Month" && mode !== "Week") {
        url.searchParams.set("mode", defaultMode);
        shouldRedirect = true;
    }

    const month = url.searchParams.get("month");
    if (!month || !/^\d{4}-\d{2}$/.test(month)) {
        url.searchParams.set("month", defaultMonth);
        shouldRedirect = true;
    }

    const week = url.searchParams.get("week");
    if (!week || !/^w\d{4}-\d{2}$/.test(week)) {
        url.searchParams.set("week", defaultWeek);
        shouldRedirect = true;
    }

    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }

    const formData = new FormData();
    formData.append("mode", url.searchParams.get("mode")!);
    formData.append("month", url.searchParams.get("month")!);
    formData.append("week", url.searchParams.get("week")!);
    for (const fleetNumber of url.searchParams.getAll("fleetNumber")) {
        formData.append("fleetNumber[]", fleetNumber);
    }
    for (const fleetNumber of url.searchParams.getAll("trendFleetNumber")) {
        formData.append("trendFleetNumber[]", fleetNumber);
    }

    const res = await myAxios({
        fileName: "fleetUsage/readFleetUsage.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");
    return res.data;
}
